export class FiltrosPagoLiquidacion{
    idProveedor :string = '';
    Moneda : number = 0;
    Estado : string = 'C';
 }